<script>
  import { alert } from 'vue-strap';
  
  export default {
    components: { alert },
    props: {
      eventos: {
        type: Array,
        required: true,
      },
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    methods: {
      deletarItem(indice) {
        this.eventos.splice(indice, 1);
      },
    },
    beforeDestroy() {

    },
    computed: {
      total: function() {
        return this.eventos.reduce((somatorio, item) => {
          const valor = this.$options.filters.formatarNumero(item.valorEstimado, true);

          return somatorio + valor;
        }, 0);
      }
    }
  }
</script>

<template>
  <div>
    <alert type="warning" v-if="eventos.length === 0">
      <i class="fa fa-warning"></i> Nenhum benefício adicionado.
    </alert>
    
    <div class="bs-callout bs-callout-info no-margin-top" v-for="(evento, index) in eventos">
      <h4>
        Item #{{ index + 1 }}

        <button type="button"
                class="btn btn-sm btn-danger btn-delete-item"
                title="Excluir item"
                @click="deletarItem(index)"
                v-if="!relatorio">
          <i class="fa fa-trash"></i>
        </button>
      </h4>

      <div class="row">
        <dl class="col-md-4">
          <dt>Benefício</dt>
          <dd>{{ evento.solicitacaoContratacaoPessoalEvento ? evento.solicitacaoContratacaoPessoalEvento.descricao : '---' }}</dd>
        </dl>
        <dl class="col-md-4">
          <dt>Valor estimado (R$)</dt>
          <dd>{{ evento.valorEstimado }}</dd>
        </dl>
      </div>

      <div class="row">
        <dl class="col-md-12">
          <dt>Observação</dt>
          <dd>{{ evento.observacao || '---' }}</dd>
        </dl>
      </div>
    </div>

    <div class="bs-callout bs-callout-primary">
      <h4>Valor total: R$ {{ total | formatarNumero }}</h4>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-contratacao-pessoal/componentes/compartilhado/FormListaEventos.vue